// meta descriptions for search engines, keyed by page route (router.pathname)
// and resolved per page at static export time. every indexable page needs its
// own text — duplicate descriptions across pages hurt SEO and get flagged by
// crawlers. utils/seo.test.ts fails when a page is added without one.
export const PAGE_DESCRIPTIONS: Record<string, string> = {
  '/': 'Stake FLIP and earn rewards, run operators or validators on Chainflip. Explore network participation through auctions, rewards and staking.',
  '/auction':
    'Monitor the current Chainflip validator auction, active bids, minimum active bid and validator rankings in real time.',
  '/delegate':
    'Delegate your FLIP tokens to Chainflip operators and earn staking rewards while helping secure the network.',
  '/epochs':
    'Browse every Chainflip epoch: date range, epoch length, bond and total FLIP bonded per epoch.',
  '/my-account':
    'Manage your Chainflip validator or operator account: balances, rewards, funding and redemptions.',
  '/network':
    'Chainflip network analytics in one place: epoch details, authority set performance, operators and validators.',
  '/operators':
    'Browse Chainflip operators, compare validator performance, delegation statistics, commissions, and historical rewards.',
};

// dynamic and not-yet-described routes fall back to the root description
export const getPageDescription = (pathname: string): string =>
  PAGE_DESCRIPTIONS[pathname] ?? PAGE_DESCRIPTIONS['/'];

// title tags, keyed like PAGE_DESCRIPTIONS. duplicate titles across pages hurt
// ranking and get flagged by crawlers, so every indexable page needs its own
export const PAGE_TITLES: Record<string, string> = {
  '/': 'Chainflip Validators, Operators & Staking',
  '/auction': 'Chainflip Validator Auctions',
  '/delegate': 'Chainflip Delegate FLIP',
  '/epochs': 'Chainflip Epochs',
  '/my-account': 'My Chainflip Account',
  '/network': 'Chainflip Network Overview',
  '/operators': 'Chainflip Operators',
};

// dynamic and not-yet-titled routes fall back to the root title
export const getPageTitle = (pathname: string): string => PAGE_TITLES[pathname] ?? PAGE_TITLES['/'];
